import { orderBy } from "lodash";
import { useMemo } from "react";
import { PublishingRoyaltyDetail } from "../models";
import { mapTypeGroup } from "../utils";
import { SortOrderMap, SortValueGetterMap } from "./constants";
import { RoyaltiesEarningsSorting } from "./models";

export function useFilteredRoyaltiesEarnings(
  earnings: PublishingRoyaltyDetail[] | undefined,
  sortEarningsBy: RoyaltiesEarningsSorting,
  selectedPeriods: string[],
  selectedSources: string[],
  selectedSongs: string[],
  type: string | null
) {

  const earningsList = useMemo(() => {
    if (!earnings) return [];

    let resultingEarnings = orderBy(
      earnings,
      [SortValueGetterMap[sortEarningsBy]],
      [SortOrderMap[sortEarningsBy]]
    );

    if (type) {
      resultingEarnings = resultingEarnings?.filter(x => mapTypeGroup(x.typeGroup) === type);
    }

    if (selectedPeriods.length > 0) {
      resultingEarnings = resultingEarnings.filter(earning => selectedPeriods.includes(earning.reportedOn));
    }

    if (selectedSources.length > 0) {
      resultingEarnings = resultingEarnings.filter(earning => selectedSources.includes(earning.source));
    }

    if (selectedSongs.length > 0) {
      resultingEarnings = resultingEarnings.filter(earning => selectedSongs.includes(earning.songTitle as string));
    }

    return resultingEarnings;
  }, [earnings, sortEarningsBy, selectedPeriods, selectedSources, selectedSongs]);

  return earningsList;
}